import { useSyncExternalStore } from "react";

/**
 * Хлебные крошки, которые страница задаёт сама.
 *
 * Верхняя панель строит крошки по маршруту (pageMeta), но некоторым страницам
 * нужен свой, более подробный путь — например, карточка пациента:
 * «Пациенты → Иванов И. И. → План лечения → …».
 *
 * Страница вызывает setPageCrumbs(pathname, items), Topbar забирает их через
 * usePageCrumbs(pathname) и использует, пока путь совпадает.
 */

let state = { path: "", items: null };
const listeners = new Set();

const emit = () => {
  listeners.forEach((listener) => listener());
};

export const setPageCrumbs = (path, items) => {
  state = { path: String(path || ""), items: items || null };
  emit();
};

export const clearPageCrumbs = () => {
  state = { path: "", items: null };
  emit();
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const getSnapshot = () => state;

export const usePageCrumbs = (pathname) => {
  const snapshot = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  if (!snapshot.items || !snapshot.path) return null;
  return snapshot.path === pathname ? snapshot.items : null;
};

export default usePageCrumbs;
